import { FC } from "react";

import {
  Alert,
  AlertTitle,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";

import { PingClusterResult as PingClusterResultType } from "@/hooks/use-ping-cluster";

type PingClusterError = {
  code: string;
  message: string;
};

type PingClusterResultProps = {
  clusterIp?: string;
  result?: PingClusterResultType;
  error?: PingClusterError;
  customPort: string;
};

const PingClusterResult: FC<PingClusterResultProps> = ({
  clusterIp,
  result,
  error,
}) => {
  return (
    <Box>
      {result?.success ? (
        <Alert severity="success">
          Cluster connected from{" "}
          <Typography sx={{ fontFamily: "monospace" }}>{clusterIp}</Typography>
        </Alert>
      ) : error ? (
        <Alert severity="warning">
          Pomerium connected, but there was an error: <br />
          <br />
          <Typography variant="body2">{error.message}</Typography>
        </Alert>
      ) : result?.loading ? (
        <Alert icon={<CircularProgress size={20} />} severity="warning">
          Checking cluster connection...
        </Alert>
      ) : (
        <>
          <Alert severity="info" icon={<CircularProgress size={20} />}>
            <AlertTitle>Waiting for Pomerium Connection...</AlertTitle>
            <Typography variant="body1">
              There is no need to refresh the page. You will be updated when
              Pomerium successfully connects.
            </Typography>
          </Alert>
        </>
      )}
    </Box>
  );
};
export default PingClusterResult;
